import { selectMedia } from "./media";

export const selectCategory = ({ heading, items }) => ({
  heading,
  items: items.map((item) => selectMedia(item)),
});
